export default __webpack_public_path__ + "static/media/offboard-members-icon.4728ab88.svg";